import { spacing, Touchable, Typography } from "@stepapp/ui";
import React, { useCallback } from "react";
import { Linking, Platform, StyleSheet } from "react-native";

type Props = {
  label: string;
  link?: string;
  onPress?: () => void;
  underline?: boolean;
};

const HeaderButton = ({ onPress, label, link, underline = false }: Props) => {
  const handlePress = useCallback(() => {
    if (link) {
      Linking.openURL(link);
    } else {
      onPress?.();
    }
  }, [link, onPress]);

  return (
    <Touchable onPress={handlePress} style={styles.container}>
      <Typography variant="paragraphBold" style={underline && styles.underline}>
        {label}
      </Typography>
    </Touchable>
  );
};

export default React.memo(HeaderButton);

const styles = StyleSheet.create({
  container: {
    marginRight: spacing.unit * 3,
  },
  underline: {
    textDecorationStyle: "solid",
    textDecorationLine: "underline",
    ...Platform.select({
      web: { textUnderlineOffset: 2 },
    }),
  },
});
